/* eslint-disable import/prefer-default-export */
export function toThousandth(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}



// WEBPACK FOOTER //
// ./src/filters/index.js